setTimeout(function(){
function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

let auth_payload = {},
    auth_at = readCookie("LOREX_ACCESS_TOKEN"),
    auth_rt = readCookie("LOREX_ID_TOKEN");
if (auth_at !== null && auth_rt !== null) {
    auth_payload = {
        "accessToken": auth_at,
        "refreshToken": auth_rt,
    }
}

let translation = {
    "en": {
      "ujet_start_title": "Chat with us! We are here to help. \n\r \n\r By using this chat feature, you consent to collection, recording and use of information about you and this chat session by Lorex Corporation and authorized service providers acting on Lorex Corporation's behalf for quality assurance and training purposes. Lorex Corporation may use or disclose this information, including the chat content, in accordance with its Privacy Policy, located at https://www.lorex.com/pages/privacy-policy . If you do not consent to these terms, please do not use this chat feature and reach out to us via email or by phone. By continuing to interact with or communicating with us using this chat feature you will be deemed to accept these terms. \n\r \n\r Would you like to continue?",
      "ujet_greeting": "Hi there! How can we help you?"
    }
};

var ujet = new UJET({
    companyId: '15502692993152654f668b948f4275d2b',
    authenticate: getMyAuthToken,

    launcher: {
        cssText: '.wrap button #chat,.wrap button #minimize{transform: scale(0.65);}',
        chatIcon: 'https://cdn.lorex.com/lorexcss/plugins/ujet/chat-icon.svg',
        closeIcon: 'https://cdn.lorex.com/lorexcss/plugins/ujet/chat-icon.svg',
        style: {
          '--background-color': '#FFFFFF'
        }
    },
    logo: 'https://cdn.lorex.com/lorexcss/plugins/ujet/lorex-roundel.png',
    
    defaultLanguage: "en",
    translation: translation,
});

function getMyAuthToken() {
    return fetch('https://yz6s785rh3.execute-api.us-east-1.amazonaws.com/prod/sign', {
        method: "POST",
        headers: {
            "x-api-key": "416FUIaz2N4AUxRjMYgk5a1Wjn14O0kt2zQHhEpA",
            "Content-Type": "application/json",
            "Accept": "application/json",
            "Cache-Control": "no-cache"
        },
        body: JSON.stringify({
            "payload": auth_payload
        }
                            )
    })
    .then(function (resp) {
        return resp.json();
    });
}
}, 5000); 